import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import * as bookingActions from '../../../store/actions/booking.action';
import { Store } from '@ngrx/store';
import { State } from '../../../store/reducers';
import { map } from 'rxjs/operators';
import { Booking } from '../../models/booking';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-accomodationinfo',
  templateUrl: './accomodationinfo.component.html',
  styleUrls: ['./accomodationinfo.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AccomodationinfoComponent implements OnInit, OnDestroy {
  accomodationinfoForm: FormGroup;
  mealList;
  mealsObject;
  arrivalMinDate = new Date();
  departureMinDate = new Date();
  mealsSubscription: Subscription;
  constructor(
    private fb: FormBuilder,
    private store: Store<State>,
    private router: Router
  ) {}

  ngOnInit() {
    this.createForm();
    // this.store
    //   .select(state => state.booking.currentBooking)
    //   .subscribe(booking => this.createForm(booking));
    this.accomodationinfoForm
      .get('arrivalDate')
      .valueChanges.pipe(
        map(dateString => {
          this.departureMinDate = dateString
            ? new Date(dateString)
            : new Date();
        })
      )
      .subscribe();

    this.mealsSubscription = this.store
      .select(state => state.booking.meals)
      .subscribe(meals => {
        this.mealsObject = meals;
        this.mealList = Object.keys(meals);
      });
  }

  createForm() {
    this.accomodationinfoForm = this.fb.group({
      arrivalDate: new Date('2018-05-16T12:00:00'),
      departureDate: new Date('2018-05-19T12:00:00'),
      meal1: '',
      meal2: '',
      meal3: '',
      otherInfo: ''
    });
  }

  submitAccommodationInfo() {
    this.store.dispatch(
      new bookingActions.AddAccommodationInfo(this.accomodationinfoForm.value)
    );
    this.router.navigate(['/bookings/add/room-choice']);
  }

  cancel() {
    this.router.navigate(['/bookings']);
  }

  ngOnDestroy() {
    if (this.mealsSubscription) {
      this.mealsSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/accomodationinfo/accomodationinfo.component.ts